import { render, staticRenderFns } from "./NbaTeamProfile.vue?vue&type=template&id=1b4bcc76&scoped=true"
import script from "./NbaTeamProfile.vue?vue&type=script&lang=js"
export * from "./NbaTeamProfile.vue?vue&type=script&lang=js"
import style0 from "./NbaTeamProfile.vue?vue&type=style&index=0&id=1b4bcc76&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1b4bcc76",
  null
  
)

export default component.exports